export default {
  init() {
    // if ($('.video-thumbnail').length > 0) {
    //   $('#video-modal').on('show.bs.modal', function (e) {
    //     const button = $(e.relatedTarget)
    //     const video = $(button).data('video')
    //     $(this).find('.modal-body iframe').attr('src', 'https://www.youtube.com/embed/' + video + '?feature=oembed&rel=0&modestbranding=1&showinfo=0&controls=0&autoplay=1&loop=1');
    //   }).on('hide.bs.modal', function () {
    //     $(this).find('.modal-body iframe').attr('src', '');
    //   })
    // }

    $('[data-bs-toggle="tooltip"]').tooltip({
      'boundary': 'window',
    });

    $('[data-bs-toggle="tooltip"]').hover(function () {
      $(this).toggleClass('active');
    });

    $('.hotspots .nav-link').on('shown.bs.tab', function () {
      $('html, body').scrollTop($('.col-content').offset().top - 120);
    });



    // JavaScript to be fired on the single interactive map
  },
  finalize() {
    // JavaScript to be fired on the single interactive map, after the init JS



  },
};


// WEBPACK FOOTER //
// ./scripts/routes/single-interactive-map.js